import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-home',
  templateUrl: './icon-home.component.html',
  styles: []
})
export class IconHomeComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
